/**
 * @file banner
 * @author
 */

import React, {Fragment} from 'react';
import {Carousel} from 'antd';
import AuthButton from '../attest/authButton';

export default function Banner(props) {
    /* eslint-disable */
    return (
        <Fragment>
            <div className="banner">
                <Carousel
                    className="custom-carousel-class"
                    autoplay
                >
                    <div className="carousel-item">
                        <div className="item-info-wrapper">
                            {/* <p className="title">百度企业号码认证</p> */}
                            <p className="title">
                                来电名片认证服务
                            </p>
                            <p className="title-tip">
                                呼入呼出时企业号码不再陌生，大幅提高接通率
                            </p>
                            <div className="thread-tips">
                                <AuthButton
                                    {...props}
                                    type="banner-btn"
                                    name="立即申请"
                                    subName="限时免费试用7天"
                                />
                            </div>
                        </div>
                    </div>
                </Carousel>
            </div>
        </Fragment>
    );
}
